import api from "Common/Client/Interceptor";
import { toArray } from "Common/utils/list";
const getToken = () => localStorage.getItem("token");

export const fetchCourses = async (mentorId) => {
  try {
    const response = await api.get(`/Library/Mentor/Get-Courses-List?mentorId=${mentorId}&pageNumber=1&pageSize=30`, {
      headers: { Authorization: `Bearer ${getToken()}` },
      suppressErrorToast: true,
    });
    return toArray(response.data);
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};